export default __webpack_public_path__ + "static/media/dark_lock-key-alt_icon.b2d159d2.svg";